// extracted by mini-css-extract-plugin
module.exports = {"ctaImageWrapper":"PremiumSwellSpectraCTAImageStyles_ctaImageWrapper__66E_E","graphSwellSpectraCTAImage":"PremiumSwellSpectraCTAImageStyles_graphSwellSpectraCTAImage__nTvOa"};